<template>
  <div id="app">
    <div class="con">
     
      <div class="currScore">
        <p>我的荣誉值：{{ currWinNums }}</p>
        <div class="currCoreReadme"></div>
        <a href="javascript:;" class="btn_refresh" @click="pageModel()"></a>
      </div>

      <!-- <a href="javascript:;" class="chongzhi_btn" :class="`${resetState}`" @click="resetBtn">
            <span class="cz_rule"></span>
          </a> -->
      <a href="javascript:;" class="btn_qw" @click="(changeShow = true), (maskShow = true)">
        <span v-if="showRedpoint" class="redpoint"></span>
      </a>
      <a href="javascript:;" class="rule_btn" @click="(ruleShow = true), (maskShow = true)"></a>
      <div>
        <a href="javascript:;" class="left_btn" :class="{ 'cant': initNum == 0 }" @click="moveLeft"></a>
        <a href="javascript:;" class="right_btn" :class="{ 'cant': initNum == 3 }" @click="moveright"></a>
      </div>
      <div class="win_list">
        <div class="move_con" :style="moveCss">
          <winItem v-for="ai in winList" :key="ai.Id" :id="ai.Id" :imgArr="getImgID(ai.Id)" :winMax="ai.Amount"
            :flag="ai.Flag" :val="ai.Val" :heroList=heroInstance(ai.Id)>
          </winItem>
        </div>
      </div>
      <div class="page_points clearfix">
        <div class="point">
          <span v-for="(s, index) in points" :key="index" :class="{ 'on': s.num == initNum }"
            @click="pageMove(s.num)"><b></b></span>
        </div>
      </div>
      <div class="key_con">
        <keyItem :keyNum="keyNum" :offline="offline" :keyStr="keyStr" :drawKeyNum="drawKeyNum" :gameNum="gameNum" />
      </div>
      <div class="win_list2">
        <winItem2 :id="winList2.Id" :imgArr="getImgID(winList2.Id)" :winMax="winList2.Amount">
        </winItem2>
      </div>

    </div>
    <div class="mask" v-show="maskShow"></div>
    <div class="rule_alert" v-show="ruleShow">
      <a href="javascript:;" class="close" @click="(ruleShow = false), (maskShow = false)"></a>
      <div class="rule_con">
        <div>
          <p>一、累计获得不同荣誉可获得以下奖励
          </p>
          <p>250荣誉：达人虎符*125、翠珏*15、巳蛇宝匣*1
          </p>
          <p>500荣誉：达人虎符*125、灵魂碎片*100、翠珏*30
          </p>
          <p>1000荣誉：达人虎符*150、巳蛇宝匣*1、翠珏*30、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>1500荣誉：达人虎符*150、灵魂碎片*200、翠珏*30、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>2000荣誉：达人虎符*150、巳蛇宝匣*1、翠珏*30、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>2750荣誉：达人虎符*175、灵魂碎片*300、翠珏*45、钥匙碎片*50、星集市400星钻饰品立减券*1
          </p>
          <p>3500荣誉：达人虎符*175、翠珏*45、巳蛇宝匣*1、钥匙碎片*50、星集市400星钻饰品立减券*1
          </p>
          <p>4250荣誉：达人虎符*175、灵魂碎片*300、翠珏*45、钥匙碎片*50、星集市400星钻饰品立减券*1
          </p>
          <p>5000荣誉：达人虎符*175、翠珏*45、巳蛇宝匣*1、钥匙碎片*50、星集市400星钻饰品立减券*1
          </p>
          <p>6000荣誉：达人虎符*200、翠珏*60、钥匙碎片*75、随机获得一款属性皮肤
          </p>
          <p>属性皮肤随机池：90%红色（其中红色卓越2%），10%金色
          </p>
          <p>7000荣誉：达人虎符*200、灵魂碎片*300、翠珏*60、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>8000荣誉：达人虎符*200、翠珏*60、巳蛇宝匣*1、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>9000荣誉：达人虎符*200、灵魂碎片*300、翠珏*60、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>10000荣誉：达人虎符*200、翠珏*60、巳蛇宝匣*1、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>11000荣誉：达人虎符*200、灵魂碎片*300、翠珏*60、钥匙碎片*25、星集市400星钻饰品立减券*1
          </p>
          <p>12000荣誉：达人虎符*200、翠珏*60、巳蛇宝匣*1、钥匙碎片*25、随机获得一款属性皮肤
          </p>
          <p>属性皮肤随机池：90%红色（其中红色卓越2%），7%金色，3%无双金色</p>
          <p>当累计满12000荣誉、往后每再累计满2000荣誉：达人虎符*200、灵魂碎片*100、翠珏*80、巳蛇宝匣*1、钥匙碎片*40</p>
          <p style="padding-top: 15px">二、荣誉说明：
          </p>
          <p>1、武勋局胜利方，玩家获得荣誉 = 玩家MVP值 ，单局最高250
          </p>
          <p>2、武勋局失败方，玩家获得荣誉 =（玩家MVP值 - 敌方平均MVP值）÷2，不计负值（上限为胜利方MPV平均值的1/2）
          </p>
          <p>3、逃跑玩家将扣除荣誉，扣除荣誉 = 胜利方MVP平均值÷2
          </p>
          <p style="padding-top: 15px">三、毋遁之礼活动规则
          </p>
          <p>1、活动上线后，每累计5胜场（注：武勋局及中途局需满足20分钟以上）可领取1把金钥匙
          </p>
          <p>2、活动期间内，最多可领取6把金钥匙
          </p>
          <p>3、每次逃跑会重置累胜至0场（仅针对毋遁之礼活动），并将金钥匙最大可领数量减1（最多减至0）</p>
          <p style="padding-top: 15px">四、活动时间：2025年4月2日
          </p>
          <p>活动下线时间另行通知
          </p>
        </div>
      </div>
    </div>
    <div class="award_alert" :class="{ 'award_alert_big': msgtp == 2 && heroInstance(curId) != null }" v-show="alertShow">
      <div class="award_con">
        <div class="mes_erro" v-if="msgtp == 3" v-html="mesErro"></div>
        <div class="jl_wrap" v-for="keyAwarditem in awardMsg.arr" :key="keyAwarditem.index" v-else-if="msgtp == 1">
          <div class="img">
            <img :src="`https://static.7fgame.com/itemimg/${keyAwarditem.AwardId}.jpg`" width="60" height="60"
              :title="getTip(keyAwarditem.AwardName)" />
          </div>
          <p class="jl_nums">x{{ keyAwarditem.Amount }}</p>
        </div>
        <div v-else-if="msgtp == 2">
          <div class="spec_award" v-if="heroInstance(curId) != null">
            <img :src="`https://pic2.7fgame.com/qxresource//${heroInstance(curId).ItemId}.png`"
              width="128" height="177" />
            <div :class="`bor_${pfBor(heroInstance(curId).Quality,heroInstance(curId).ItemId)}`"></div>
            <div class="hero_tips">
              <p class="p1" :class="heroInstance(curId).Quality ==4?'red':''">{{heroInstance(curId).ItemName}}</p>
              <p v-html="itemAttr(heroInstance(curId).ItemAttrs)" class="attr_det"></p>
            </div>
          </div>
          <div class="normal_award">
            <div class="jl_wrap" v-for="awarditem in awardMsg2.arr.filter(item =>item.AwardType !=4)" :key="awarditem.index">
              <div class="img">
                <img :src="`https://static.7fgame.com/itemimg/${awarditem.AwardId}.jpg`" width="60" height="60"
                  :title="getTip(awarditem.AwardId)" />

              </div>
              <p class="jl_nums">
                {{ "x" + awarditem.Amount }}
              </p>
            </div>
          </div>
          <a v-if="curId == 10 || curId == 16"
            href="javascript:window.parent.leftDH.toPageRef(95);"
            class="qw_bag">前往背包查看</a>
        </div>


        <div class="jl_wrap" v-if="msgtp == 4">
          <div class="img"><img :src="getImg" width="60" height="60" /></div>
          <p class="jl_nums">x{{ getNums }}</p>
        </div>
      </div>
      <a href="javascript:;" class="sure_btn" @click="(alertShow = false), (maskShow = false)"></a>
      <a href="javascript:window.parent.leftDH.toPageRef(6);" class="toxjsLink" v-if="showToXjx">前往使用优惠券</a>
      <div v-html="getCuijue" class="cj_tip"></div>
    </div>
    <div class="change_tip" v-show="changeShow">
      <div class="change_tip_con">
        是否切换至周年庆活动？<br>说明：切换后，踏青拾春将暂停荣誉累积（随时可返回本活动）
      </div>
      <div class="change_btns">
        <a href="javascript:;" class="sure_btn" @click="changeAct"></a>
        <a href="javascript:;" class="qx_btn" @click="(changeShow = false), (maskShow = false)"></a>
      </div>
    </div>

  </div>
  <imgLoad></imgLoad>
</template>

<script setup>
import "./assets/css/global.css";
import imgLoad from "./components/imgLoad.vue";
import keyItem from "./components/keyItem.vue";
import winItem from "./components/winItem.vue";
import winItem2 from "./components/winItem2.vue";
import getTip from "./utils/global";
import http from "./utils/request";
import { ref, reactive, onMounted, onBeforeMount, computed,watch, inject } from 'vue';
import { storeToRefs } from 'pinia';
import { useStore } from './store/index';
import emitter from "./utils/bus";
const store = useStore();
let { currWinNums,drawFlag } = storeToRefs(store);

const maskShow = ref(false);
const ruleShow = ref(false);
const alertShow = ref(false);
const changeShow = ref(false);
const offline = ref(0); //逃跑局数
const keyNum = ref(0); //钥匙点亮数量
const drawKeyNum = ref(0); //已领取钥匙数
const gameNum = ref(0);
const keyStr = ref(''); //每个钥匙状态
const msgtp = ref(0);  //弹框消息类型
const mesErro = ref('');
const itemWidth = 608;
const initNum = ref(0); //列表初始位置
// const moveCss = ref("");
let curId = ref(0);

// const jsonObj = eval('(' + ExStr+ ')');
//特殊奖励英雄皮肤弹框内容
const heroList = reactive({
  arr: []
});
//钥匙弹框内容
const awardMsg = reactive({
  arr: []
});
const awardMsg2 = reactive({
  arr: []
})//武勋领奖弹框信息
const winList = reactive(
  [{"Id":1,"Flag":1,"Amount":250,"Val":0},{"Id":2,"Flag":2,"Amount":500,"Val":0},{"Id":3,"Flag":4,"Amount":1000,"Val":1},{"Id":4,"Flag":8,"Amount":1500,"Val":1},{"Id":5,"Flag":16,"Amount":2000,"Val":1},{"Id":6,"Flag":32,"Amount":2750,"Val":1},{"Id":7,"Flag":64,"Amount":3500,"Val":1},{"Id":8,"Flag":128,"Amount":4250,"Val":1},{"Id":9,"Flag":256,"Amount":5000,"Val":1},{"Id":10,"Flag":512,"Amount":6000,"Val":0},{"Id":11,"Flag":1024,"Amount":7000,"Val":1},{"Id":12,"Flag":2048,"Amount":8000,"Val":1},{"Id":13,"Flag":4096,"Amount":9000,"Val":1},{"Id":14,"Flag":8192,"Amount":10000,"Val":1},{"Id":15,"Flag":16384,"Amount":11000,"Val":1},{"Id":16,"Flag":32768,"Amount":12000,"Val":0}]
)
const winList2 = reactive(
  { "Id": 17, "Flag": 65536, "Amount": 12000, "TypeId": 2, "Val": 2000 }
)
const imgList = reactive(
  [{"Id":1,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":125},{"Id":1,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":15},{"Id":1,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":2,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":125},{"Id":2,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":100},{"Id":2,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":30},{"Id":3,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":150},{"Id":3,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":30},{"Id":3,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":3,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":3,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":4,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":150},{"Id":4,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":200},{"Id":4,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":30},{"Id":4,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":4,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":5,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":150},{"Id":5,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":30},{"Id":5,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":5,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":5,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":6,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":175},{"Id":6,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":300},{"Id":6,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":45},{"Id":6,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":50},{"Id":6,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":7,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":175},{"Id":7,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":45},{"Id":7,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":7,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":50},{"Id":7,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":8,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":175},{"Id":8,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":300},{"Id":8,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":45},{"Id":8,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":50},{"Id":8,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":9,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":175},{"Id":9,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":45},{"Id":9,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":9,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":50},{"Id":9,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":10,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":10,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":10,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":75},{"Id":10,"AwardType":4,"AwardId":0,"AwardName":"特殊奖励","Amount":1},{"Id":11,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":11,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":300},{"Id":11,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":11,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":11,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":12,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":12,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":12,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":12,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":12,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":13,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":13,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":300},{"Id":13,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":13,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":13,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":14,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":14,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":14,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":14,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":14,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":15,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":15,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":300},{"Id":15,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":15,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":15,"AwardType":1,"AwardId":5004997,"AwardName":"星集市饰品立减券","Amount":1},{"Id":16,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":16,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":60},{"Id":16,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":16,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":25},{"Id":16,"AwardType":4,"AwardId":0,"AwardName":"特殊奖励","Amount":1},{"Id":17,"AwardType":1,"AwardId":242944,"AwardName":"达人虎符","Amount":200},{"Id":17,"AwardType":1,"AwardId":5003611,"AwardName":"灵魂碎片","Amount":100},{"Id":17,"AwardType":1,"AwardId":5004216,"AwardName":"翠珏","Amount":80},{"Id":17,"AwardType":1,"AwardId":5005114,"AwardName":"巳蛇宝匣","Amount":1},{"Id":17,"AwardType":2,"AwardId":2,"AwardName":"钥匙碎片","Amount":40}]
)

// const heroImgList = reactive(
//   [ {"Id":10,"AwardType":4,"AwardId":1,"AwardName":"蓝色OR无双","Amount":1}, {"Id":16,"AwardType":4,"AwardId":2,"AwardName":"红色OR无双","Amount":1},]
// )

watch(() =>currWinNums.value, (oldValue,newValue) => {
  if(oldValue!=newValue){
    firstMove()
  }
}); 
const moveLeft = function () {
  if(initNum.value == 0) return;
  else initNum.value--;
};
const moveright = function () {
  if (initNum.value >= 3) return;
  else initNum.value++;
};
const points = reactive(
  [{ "num": 0 }, { "num": 1 }, { "num": 2 }, { "num": 3 }]
)
const pageMove = function (n) {
  initNum.value = n;
};
// const heroAttr = function(id){
//   let heroInfor = heroInstance(id);

//   let heroStr = `<p style="color:${heroInfor.Quality==4?'red':'yellow'};">${heroInfor.ItemName}</p>${heroInfor.ItemAttrs.replace(/,/g,"<br/>")}`;
//   return heroStr;

// }
const heroInstance = (id) => {
  var heros = heroList.arr.filter(h => h.Id == id);
  if (heros.length > 0) return heros[0];
  else return null;
};
const itemAttr = function(attr){//属性暴击判断
    const t = attr.split(',');
    let attrtext = "";
    t.forEach(function(item){
      if(item.indexOf('〡') != -1){
        attrtext += `<p style="color:#00ff00">${item}</p>`;
      }
      else if(item.indexOf('〢') != -1){
        attrtext += `<p style="color:#eb4b4b">${item}</p>`;
      }
      else if(item.indexOf('〣') != -1){
        attrtext += `<p style="color:#e6b41e">${item}</p>`;
      }
      else{
        attrtext += `<p>${item}</p>`;
      }
    })
    return attrtext;
};

//皮肤边框
const pfBor = function(q,id){
  var wushuangs = [5004635,5004646,5004652,5004697,5004760,5004790,5004844,5004892,5004893,5004941,5004942,5004988,5004990];
  var zhuoyue = [5004649,5004562];
  if(wushuangs.indexOf(id) != -1) return 'ws';
  if(zhuoyue.indexOf(id) != -1) return 'zy';
  return q;
}

const getImgID = function (id) {
  let imgArr = reactive([])
  imgArr = imgList.filter(item => item.Id == id)
  return imgArr;
 }
// const initFirstNotDrawId = computed(()=>{
//   for(let i=0; i<winList.length;i++){
//     if(currWinNums.value >= winList[i].Amount && (drawFlag.value & winList[i].Flag) != winList[i].Flag){     
//       return winList[i].Id;
//     }
//   }
//   return 0;
// })

const  moveCss = computed(()=>{
    return `left:-${initNum.value * itemWidth}px;transition:all 0.5s`;
})
const firstMove = function () {
//  1、如果有奖励未领取，定位到第一档未领取的奖励位置。
// 2、如果没有奖励需要领取，定位到正在进行的那一档
  let notDrawId = 16; 
    for(let i=0; i<winList.length;i++){
      if((drawFlag.value & winList[i].Flag) != winList[i].Flag){     
        notDrawId = winList[i].Id;
        break;
      }
    }
  initNum.value = parseInt((notDrawId-1)/4); 
}



  const showToXjx = computed(() => {
  return awardMsg2.arr.filter(m => m.AwardId == 5004997).length > 0
})

const getImg = function (AwardId, AwardType) {
  if (AwardId > 0 && AwardType > 0) {
    if (AwardType == 4) {
      return require(`@/assets/img/${AwardId}_${AwardType}.png`);
    }
    else {
      return require(`@/assets/img/${AwardId}_on.png`);
    }
  }
  return ""
}
// const initMove = computed(()=>{
//   for(let i=0; i<winList.length;i++){
//     if(currWinNums >= winList[i].Amount && (drawFlag & winList[i].Flag) != winList[i].Flag){
//       if(winList[i].Id > 11){
//         return 11;
//       }
//       return winList[i].Id -1;
//     }
//   }
//   return 0;
// })
const pageModel = () => {
  http.get("ActTask/GetInitData")
    .then((res) => {
      let ro = res.Obj;
      if (ro != null) {
        store.setCurrWinNums(ro.Amount);
        store.setDrawFlag(ro.DrawFlag);
        store.setSumNum(ro.SumNum);
        store.setDrawSumNum(ro.DrawSumNum);
        keyNum.value = ro.KeyNum;
        offline.value = ro.Offline;
        drawKeyNum.value = ro.DrawKeyNum;
        gameNum.value = ro.GameNum;
        keyStr.value = ro.KeyStr;
        heroList.arr = JSON.parse(ro.ExStr);
        firstMove();
         //小红点页面初始化处理
         if (window.parent.redArr) {
              window.SetRedDots(window.parent.redArr);
          }

      }
    })
}
window._reload = function () {
  pageModel();
}
const changeAct = function () {
  http.get("ActTask/SetUserActId", {
    params: {
      id: preActId,
    },
  })
    .then(() => {
      window.location.href = `../ActTask${preActId}/index.html`;
    })

}
function GetNodeVal(items, id) {
    let item = items.find(i => i.RD === id);
    if (!item) return 0;
    let children = items.filter(i => i.PD === id);
    let sum = item.V;
    for (let child of children) {
        sum += GetNodeVal(items, child.RD);
    }
    return sum;
}
let showRedpoint = ref(false);
let preRedId = 53;//上一期小红点
let preActId = 12;//上一期活动id
//设置小红点状态 
window.SetRedDots = function(redArr){
  var val = GetNodeVal(redArr, preRedId);
  if (val > 0)
      showRedpoint.value = true;
  else
      showRedpoint.value = false;
}
const QueryIndexInfo = inject("QueryIndexInfo");
//计算是否有翠珏
const getCuijue = computed(()=>{
  let cj = awardMsg2.arr.filter(item => item.AwardId == 5004216);
  if(cj.length>0 ){
    let objIndex = QueryIndexInfo();
    if (objIndex != undefined && objIndex != null) {
        if (objIndex.Percentage != 100) {
            return objIndex.Tips;
        }
    }
  }
  return null;
})

onMounted(() => {
  pageModel();
  emitter.on("showaward", (data) => {
    awardMsg2.arr = [];
    //钥匙
    if (data.msgtype == 1) {
      awardMsg.arr = data.msg;
      drawKeyNum.value = keyNum.value;
    } 
    else if(data.msgtype == 2) {//奖励
      curId = data.id;
      if(data.id == 17) store.setSumNum(data.update);
      if (data.id ==10 || data.id == 16) heroList.arr.push(JSON.parse(data.heromsg));
      awardMsg2.arr = data.msg;
      console.log(data.msg);
      

    } 
    else if (data.msgtype == 3) mesErro.value = data.msg;
    msgtp.value = data.msgtype;
    maskShow.value = !maskShow.value;
    alertShow.value = !alertShow.value;
  });
});
onBeforeMount(() => {
  emitter.off('showaward')
})
</script>
<style>
.con {
  position: relative;
  width: 1110px;
  height: 660px;
  background: url("./assets/img/bg.jpg") 0 0 no-repeat;
}

.btn_refresh {
  position: absolute;
  top: 1px;
  right: 15px;
  width: 20px;
  height: 20px;
  background: url("./assets/img/btn_sx.png") 0 0 no-repeat;
}
.btn_refresh:hover {
  background-position: 0 -20px;
}
.btn_refresh:active {
  background-position: 0 -40px;
}
.con .currScore {
  position: absolute;
    top: 83px;
    left: 51px;
    width: 186px;
    color: #fff1b5;
    font-size: 14px;
    z-index: 10;
    height: 23px;
    font-weight: bold;
}
.con .currScore p{
  line-height: 23px;
  padding-left:8px;
}
.con .currScore .currCoreReadme {
  display: none;
  position: absolute;
  width:289px;
  height: 166px;
  background: url("./assets/img/ry_tips.png") 0 0 no-repeat;
  top: 25px;
  left: 115px;
  z-index: 10;
}

.con .currScore:hover .currCoreReadme {
  display: block;
}

.btn_qw {
  position: absolute;
  bottom: 29px;
  left: 20px;
  z-index: 10;
  width:104px;
  height: 64px;
  background: url("./assets/img/btn_qw.png") 0 0 no-repeat;
}

.btn_qw:hover {
  background-position: 0 -64px;
}

.btn_qw:active {
  background-position: 0 -128px;
}

.chongzhi_btn {
  position: absolute;
  top: 565px;
  left: 1003px;
  width: 95px;
  height: 85px;
  background: url("./assets/img/chongzhi_btn.png") center 0 no-repeat;
  z-index: 10;
}

.chongzhi_btn:hover {
  background-position: center -85px;
}

.chongzhi_btn:active {
  background-position: center -170px;
}

.chongzhi_btn.cant {
  background-position: center -255px;
}

.chongzhi_btn .cz_rule {
  display: none;
  position: absolute;
  width: 557px;
  height: 162px;
  background: url("./assets/img/chongzhi_rule.png") 0 0 no-repeat;
  bottom: 82px;
  right: 8px;
}

.chongzhi_btn:hover .cz_rule {
  display: block;
}

.con .rule_btn {
  position: absolute;
  top: 5px;
  left: 320px;
  width: 26px;
  height: 26px;
  background: url("./assets/img/rule_btn.png") 0 0 no-repeat;
  z-index: 10;
}

.con .rule_btn:hover {
  background-position: 0 -26px;
}

.con .rule_btn:active {
  background-position: 0 -52px;
}

.win_list {
  display: flex;
  height: 500px;
  width:608px;
  overflow: hidden;
  position: relative;
  margin-left:341px;
}
.left_btn {
  pointer-events: auto;
  position: absolute;
  left: 327px;
  top: 208px;
  width:19px;
  height:95px;
  background: url("./assets/img/btn_left.png") 0 0 no-repeat;
  z-index: 8;
}
.left_btn:hover {
  background-position: 0 -95px;
}
.left_btn:active {
  background-position: 0 -190px;
}
.left_btn.cant {
  pointer-events: none;
  background-position: 0 -285px;
}
.right_btn {
  pointer-events: auto;
  position: absolute;
  right: 146px;
  top: 208px;
  width:19px;
  height:95px;
  background: url("./assets/img/btn_right.png") 0 0 no-repeat;
  z-index: 8;
}
.right_btn:hover {
  background-position: 0 -95px;
}
.right_btn:active {
  background-position: 0 -190px;
}
.right_btn.cant {
  pointer-events: none;
  background-position: 0 -285px;
}
.win_list .move_con {
  width: 8000px;
  position: absolute;
  top:0;
  left: 0;
}

.win_list2 {
  position: absolute;
  top:38px;
  right: 10px;
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
}

.rule_alert {
  width:621px;
  height: 475px;
  background: url("./assets/img/rule_alert.png") 0 0 no-repeat;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -246px 0 0 -310px;
  z-index: 101;
  padding-top: 18px;
}

.rule_alert .close {
  top: 25px;
  right: 25px;
  position: absolute;
  width:36px;
  height:36px;
  background: url("./assets/img/close1.png") 0 0 no-repeat;
}

.rule_alert .close:hover {
  background-position: 0 -36px;
}

.rule_alert .close:active {
  background-position: 0 -72px;
}

.rule_con {
  margin: 45px auto 0;
  width: 495px;
  height: 388px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 1px 0 20px;
  color: #5c4931;
  font-size: 13px;
}

/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
.rule_con::-webkit-scrollbar {
  width: 10px;
  /*对垂直流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
.rule_con::-webkit-scrollbar-track {
  background-color: #866126;
}

/*定义滑块颜色、内阴影及圆角*/
.rule_con::-webkit-scrollbar-thumb {
  background: #fff8aa;
  width: 8px;
  border: #866126 1px solid;
}

/*定义两端按钮的样式*/
.rule_con::-webkit-scrollbar-button {
  background-color: #866126;
  height: 0;
}

.rule_con p {
  padding-top: 5px;
}

.rule_tt {
  color: #ffd7c0;
  font-size: 28px;
  text-align: center;
}

.award_alert {
  position: fixed;
  width: 451px;
  height: 270px;
  background: url("./assets/img/alert.png") 0 0 no-repeat;
  top: 50%;
  left: 50%;
  margin: -135px 0 0 -225px;
  z-index: 101;
}

.award_alert_big {
  height: 463px;
  background: url("./assets/img/alert2.png") 0 0 no-repeat;
  margin: -231px 0 0 -225px;
}

.award_alert .close {
  top: 14px;
  right: -13px;
  position: absolute;
  width: 36px;
  height: 36px;
  background: url("./assets/img/close1.png") 0 0 no-repeat;
}

.award_alert .close:hover {
  background-position: 0 -36px;
}

.award_alert .close:active {
  background-position: 0 -72px;
}

.award_alert .sure_btn {
  margin: 20px auto 0;
  display: block;
  width:84px;
  height:30px;
  background: url("./assets/img/btn_sure.png") 0 0 no-repeat;
}

.award_alert .sure_btn:hover {
  background-position: 0 -30px;
}

.award_alert .sure_btn:active {
  background-position: 0 -60px;
}

.award_alert .award_con {
  padding-top: 84px;
  display: flex;
  align-content: space-between;
  justify-content: center;
}

.award_alert_big .award_con {
  margin-top: 0;
}

.award_alert .award_con .mes_erro {
  color: #5c4931;
  padding:30px 0;
  font-size: 18px;
}

.award_alert .award_con .normal_award {
  display: flex;
  align-content: space-between;
  justify-content: center;
}

.award_alert .award_con .normal_award .jl_wrap.hide{
  display: none;
}
.award_alert .award_con .spec_award {
  display: flex;
  align-items: center;
  width: 128px;
  height: 177px;
  position: relative;
  margin: -15px auto 31px;
}



.spec_award .hero_tips{
  background: rgb(24 34 40 / 60%);
    position: absolute;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    width: 118px;
    min-height: 171px;
    display: none;
    z-index: 10;
    padding: 2px 4px;
    border: #212d34 1px solid;
    text-align: left;
    bottom:0;
    left:0;
}
.spec_award  .hero_tips .p1{
  color:#ffe45f;
  padding:5px 0;
  background: rgba(45,64,75,0.6);
  text-align: center;
  border-bottom:#495c69 1px solid;
  margin-bottom:5px;
}
.spec_award  .hero_tips .p1.red{
  color:#ff0000;
}
.spec_award  .hero_tips .attr_det{
  padding:0 5px 0 10px;
}
.spec_award:hover .hero_tips{
  display: block;
}
.award_alert .award_con .spec_award .bor_4 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 128px;
  height: 177px;
  background: url("./assets/img/bor_4.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

.award_alert .award_con .spec_award .bor_5 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 128px;
  height: 177px;
  background: url("./assets/img/bor_5.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

.award_alert .award_con .spec_award .bor_ws {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 128px;
  height: 177px;
  background: url("./assets/img/bor_wushuang.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
.award_alert .award_con .spec_award .bor_zy{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 128px;
  height: 177px;
  background: url("./assets/img/bor_zhuoyue.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

.award_alert .award_con .jl_wrap {
  margin: 0 6px;
}

.award_alert .award_con .jl_wrap .img {
  width: 60px;
  height: 60px;
  background:url("./assets/img/bg_icon.png") 0 0 no-repeat;
  padding: 3px;
  border-radius: 50%;
  background-size: 100% 100%;
}

.award_alert .award_con .jl_wrap .img img {
  border-radius: 50%;
}

.award_alert .award_con .jl_wrap .jl_nums {
  text-align: center;
  font-size: 14px;
  padding-top: 4px;
  color: #5c4931;
  font-weight: bold;
}

.award_alert .award_con .qw_bag {
  text-align: center;
  font-size: 12px;
  padding-top: 4px;
  color: #5c4931;
  text-decoration: underline;
  display: block;
  position: absolute;
  bottom: 50px;
  right: 50px;
}

.award_alert .award_con .jl_hero_wrap {
  position: absolute;
  width: 107px;
  height: 148px;
  top: 60px;
  left: 50%;
  margin: 0 0 0 -53px;
}

.award_alert .award_con .jl_hero_wrap .img {
  width: 107px;
  height: 148px;
  padding: 0;
  background: none;
  position: relative;
}

.award_alert .award_con .jl_hero_wrap .img img {
  border-radius: 0;
}

.award_alert .award_con .jl_hero_wrap .img .hero_infor {
  display: none;
  min-width: 135px;
  min-height: 136px;
  position: absolute;
  bottom: 0;
  left: -20px;
  z-index: 4;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 12px;
  padding: 6px;
  line-height: 19px;
}

.award_alert .award_con .jl_hero_wrap .img:hover .hero_infor {
  display: block;
}

.key_con {
  margin:19px 0 0 0;
  position: relative;
  margin-left:497px;
}


.change_tip {
  position: fixed;
  width: 431px;
  height: 270px;
  background: url("./assets/img/cz_alert.png") 0 0 no-repeat;
  top: 50%;
  left: 50%;
  margin: -135px 0 0 -215px;
  z-index: 101;
}

.change_tip .change_tip_con {
  height: 95px;
  padding:85px 45px 0;
  text-align: center;
  font-size: 18px;
  color: #5c4931;
}

.change_tip .change_btns {
  width: 100%;
  text-align: center;
}

.change_tip .change_btns a {
  display: inline-block;
  width:84px;
  height:30px;
  margin: 0 18px;
}

.change_tip .change_btns .sure_btn {
  background: url("./assets/img/btn_sure.png") 0 0 no-repeat;
}

.change_tip .change_btns .sure_btn:hover {
  background-position: 0 -30px;
}

.change_tip .change_btns .sure_btn:active {
  background-position: 0 -60px;
}

.change_tip .change_btns .qx_btn {
  background: url("./assets/img/btn_qx.png") 0 0 no-repeat;
}

.change_tip .change_btns .qx_btn:hover {
  background-position: 0 -30px;
}

.change_tip .change_btns .qx_btn:active {
  background-position: 0 -60px;
}

a.toxjsLink {
  position: absolute;
  height: 20px;
  font-size: 12px;
  color: #5c4931;
  bottom:50px;
  right:50px;
  text-decoration: underline;
}

.page_points {
  width:486px;
  margin-left: 404px;
  background: url("./assets/img/point_bg.png") 0 center no-repeat;
  height:35px;
}

.page_points .point {
  width: 160px;
  margin: 0 auto;
  text-align: center;
}

.page_points .point span {
  cursor: pointer;
  width: 38px;
  height:35px;
  background: url("./assets/img/point.png") 0 0 no-repeat;
  display:inline-block;
}

.page_points .point span b {
  display: none;
}

.page_points .point span.on b {
  display: block;
  width: 38px;
  height:35px;
  background: url("./assets/img/point_on.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
.redpoint{
  position: absolute;
  width: 14px;
  height:15px;
  background: url("./assets/img/redpoint.png") 0 0 no-repeat;
  top: 10px;
  right: 1px;
}
.cj_tip{
  position: absolute;
  bottom:-22px;
  text-align: center;
  width: 80%;
  padding:0 10%;
  color: #ffba68;
  font-size:14px;
}
</style>

